import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import './App.scss';
import './CustomStyle.scss'
import * as serviceWorker from './serviceWorker';
import { LicenseManager } from "ag-grid-enterprise";
import './styles/AgGridCustom.css';
import './components/nglteamdailyreport/component/ngl-team-daily-report-component.scss';

LicenseManager.setLicenseKey(
    'Using_this_{AG_Grid}_Enterprise_key_{AG-123368}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Keyera_Partnership,_by_its_managing_partner,_Keyera_Corp}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{5_May_2027}____[v3]_[01]_MTgwOTQ3MTYwMDAwMA==0a9ec9f9f634df90afc962ada77cbb80'
);
ReactDOM.render(<App />, document.getElementById('root'));
serviceWorker.unregister();